import { BlocksMainScene } from './blocks-main-scene';
import { BlocksApp } from '../blocks-app';
import { GameBaseScene } from 'src/games/common/phaser/game/scenes/game-base-scene';
import { BlocksListener } from '../blocks-listener';
import { TranslocoService } from '@jsverse/transloco';

export class BlocksPreloadScene extends GameBaseScene {
  public static get className(): string {
    return BlocksPreloadScene.name;
  }

  constructor(
    private blocksApp: BlocksApp,
    private localAssetPath: string,
  ) {
    super(BlocksPreloadScene.className);
  }

  public setGameListener(gameListener: BlocksListener) {
    this.blocksApp.setGameListener(gameListener);
  }

  public preloadTranslations(translocoService: TranslocoService): void {
    this.blocksApp.preloadTranslations(translocoService);
  }

  public preload() {
    this.blocksApp.preloadAssets(this, this.localAssetPath);
  }

  protected override onLoadProgress(progress: number) {
    super.onLoadProgress(progress);
  }

  protected override onLoadComplete() {
    super.onLoadComplete();

    this.scene.start(BlocksMainScene.className);
  }
}
